$(document).ready(function()
{
    let init_filter_dropdown = ($filter_dropdown) => {
        let $toggle = $filter_dropdown.find(".dropdown-toggle");
        let filter_target_id = $filter_dropdown.data("filter-target-id");
        let $filter_targets = filter_target_id ? $("."+filter_target_id) : $();
        let target_prefix = $filter_dropdown.data("target-prefix");
        if(!$filter_targets.length || !target_prefix){
            return
        }
        let combined_filter_ids_string = $filter_dropdown.data("combined-filter-ids");
        let combined_filter_ids = combined_filter_ids_string ? combined_filter_ids_string.split(",") : [];
        for(let i = 0; i < combined_filter_ids.length; i ++){
            combined_filter_ids[i] = combined_filter_ids[i].trim();
        }


        let $dropdown_items = $filter_dropdown.find(".dropdown-item");
        let none_text = $toggle.html();

        let selected_value = null;

        let apply_state = () => {
            let $selected_item = selected_value ? $dropdown_items.filter("[data-filter-value='"+selected_value+"']") : $();
            if(!$selected_item.length){
                selected_value = null;
                $toggle.html(none_text);
            } else {
                $toggle.html($selected_item.html());
            }
            $filter_dropdown.data('selected-value', selected_value);

            let filter_condition = selected_value ? "[data-"+target_prefix+"-"+selected_value+"]" : "";
            for(let i = 0; i < combined_filter_ids.length; i ++){
                let combined_filter_id = combined_filter_ids[i];
                let $combined_filter = $("#"+combined_filter_id);

                let combined_filter_target_prefix = $combined_filter.data("target-prefix");
                let combined_filter_selected_value = $combined_filter.data('selected-value');
                let combined_filter_filter_target_id = $combined_filter.data('filter-target-id');
                if(combined_filter_target_prefix && combined_filter_selected_value && combined_filter_filter_target_id === filter_target_id){
                    filter_condition += "[data-"+combined_filter_target_prefix+"-"+combined_filter_selected_value+"]";
                }
            }
            if(!filter_condition){
                $filter_targets.show();
            } else {
                $filter_targets.hide();
                $filter_targets.filter(filter_condition).show();
            }

        }

        apply_state();

        $dropdown_items.click((event) => {
            event.preventDefault();
            let $dropdown_item = $(event.target).closest(".dropdown-item");
            selected_value = $dropdown_item.data("filter-value");
            apply_state();
        })
    }


    let $filter_dropdowns = $(".filter-dropdown");

    $filter_dropdowns.each((index, element) => {
        init_filter_dropdown($(element));
    })

});